import {Customer} from "../../../customers/model/Customer";

export class BorrowerMarketingInfoComponent {

    private customer: Customer;
    private $scope: any;

    static instance = {
        controller: ['$scope', BorrowerMarketingInfoComponent],
        template: require('./borrower-marketing-info.component.html'),
        bindings: {
            customer: '<'
        }
    };

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.selectedContact = this.customer;
    }
}
